export default "__VITE_ASSET__Dzlri4qv__"